import { createUseStyles } from 'react-jss';
import { BREAK_POINT, COLOR } from '../../common/color';

const styles = {
  container: {
    width: '100vw',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    background: COLOR.white,
    '& .ck-editor': {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      '& .ck-editor__main': {
        height: '100%',
      },
    },
    '& > div': {
      flex: 1,
    },
    '& > p': {
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'right',
      marginLeft: 'auto',
      textAlign: 'right',
      color: COLOR.dodgerBlue,
      '& .material-icons': {
        cursor: 'pointer',
        padding: 15,
        fontSize: 30,
        transition: 'color 0.15s ease, opacity 0.15s ease',
        '&.disabled': {
          color: COLOR.dustyGray,
          cursor: 'not-allowed',
          pointerEvents: 'none',
          opacity: 0.6,
        },
      },
    },
  },
  invalidLink: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    padding: 24,
    textAlign: 'center',
    background: COLOR.white,
    color: COLOR.emperor,
    '& .material-icons': {
      fontSize: 48,
      color: COLOR.pomegranate,
    },
    '& span': {
      fontSize: 16,
    },
  },
};

/** @type {() => { [K in keyof typeof styles]: string }} */
export const useStyles = createUseStyles(styles);
